import React, { useState, useEffect, useRef } from 'react';
import logo from './../image/logo.png';
import { MdAdminPanelSettings, MdLogout, MdWorkOutline, MdPeopleOutline, MdOutlineBusinessCenter, MdOutlineLibraryBooks } from "react-icons/md";
import { motion } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from '../firebase.config';
import { useStateValue } from '../context/StateProvider';
import { actionType } from '../context/Reducer';
import { GrMenu } from "react-icons/gr";
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { FaInstagram, FaSearch, FaTimes } from 'react-icons/fa'; // Importing dropdown icons
import { FaRegUser, FaLinkedinIn } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import '.././index.css';
import { VscChevronUp, VscChevronDown } from "react-icons/vsc";
import { TbMessageUser } from 'react-icons/tb';
import { AiOutlineFileSearch } from "react-icons/ai";
import footer from "./../image/footer.png";
import { MdOutlineWifiCalling3 } from "react-icons/md";
import USA from './../image/3.png'
import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';

const Header = () => {
  const location = useLocation();
  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();
  const [{ user }, dispatch] = useStateValue();
  const [isMenu, setIsMenu] = useState(false);
  const [bgColor, setBgColor] = useState('bg-white');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCareersDropdownOpen, setIsCareersDropdownOpen] = useState(false);
  const [isConsultingDropdownOpen, setIsConsultingDropdownOpen] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const consultingLinkRef = useRef(null); // Ref for the Consulting link
  const consultingDropdownRef = useRef(null); // Ref for the Consulting dropdown content
  const careersLinkRef = useRef(null);
  const careersDropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [callbackFormData, setCallbackFormData] = useState({
    mobile: '',
    message: ''
  });
  const handleCallbackChange = (e) => {
    const { name, value } = e.target;
    setCallbackFormData({ ...callbackFormData, [name]: value });
  };
  const form = useRef();

 const handleCallbackSubmit = (e) => {
    e.preventDefault();

    // 1. Validation Checks
    if (!callbackFormData.mobile) {
      toast.error('Please enter your mobile number for a call back.');
      return;
    } else if (callbackFormData.mobile.length !== 10 || !/^[0-9]+$/.test(callbackFormData.mobile)) {
      toast.error('Please enter a valid 10-digit phone number for call back.');
      return;
    }

    if (!callbackFormData.message) {
      toast.error('Please enter your message for the call back request.');
      return;
    }

    // 2. Send Email with EmailJS
    emailjs
      .sendForm(
        'default_service',         // replace with your service ID
        'template_1ffzsdv',        // replace with your template ID
        form.current,              // This ref should be attached to your <form> element
        'X8hw3zSodzQIAevCJ'        // replace with your public key
      )
      .then((result) => {
        console.log('EmailJS Success:', result.text);
        // Display success toast after successful submission
        toast.success('Your call back request has been submitted successfully!');
        
        // 3. Reset form data and close modal on success
        setCallbackFormData({ mobile: '', message: '' });
        setIsOpen(false); // Only close the modal/form if the email was actually sent
      })
      .catch((error) => {
        console.error('EmailJS Error:', error.text);
        // Display error toast if submission fails
        toast.error('Failed to send your call back request. Please try again.');
      });
  };

  const handleConsultingClick = () => {
    if (!isConsultingDropdownOpen) {
      setIsConsultingDropdownOpen(true);
    }
  };
  const handleCareersClick = () => {
    if (!isCareersDropdownOpen) {
      setIsCareersDropdownOpen(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isConsultingDropdownOpen &&
        consultingLinkRef.current &&
        !consultingLinkRef.current.contains(event.target) &&
        consultingDropdownRef.current &&
        !consultingDropdownRef.current.contains(event.target)
      ) {
        setIsConsultingDropdownOpen(false); // Close if open and clicked outside both link and content
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside); // Cleanup
    };
  }, [isConsultingDropdownOpen]); // Re-run when the dropdown's open state changes
  useEffect(() => {
    const handleClickOutsideCareers = (event) => {
      if (isCareersDropdownOpen &&
        careersLinkRef.current &&
        !careersLinkRef.current.contains(event.target) &&
        careersDropdownRef.current &&
        !careersDropdownRef.current.contains(event.target)
      ) {
        setIsCareersDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutsideCareers);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideCareers);
    };
  }, [isCareersDropdownOpen]);


  const navigate = useNavigate()
  const linkRef = useRef(null);
  const [lineWidth, setLineWidth] = useState(0);

  // Update the line width when the component mounts or when the path changes
  useEffect(() => {
    if (linkRef.current) {
      setLineWidth(linkRef.current.offsetWidth); // Get the width of the link element
    }
  }, [location.pathname]); // Re-run when the path changes

  const login = async () => {
    if (!user) {
      try {
        const result = await signInWithPopup(firebaseAuth, provider);
        const { user: { providerData } } = result;

        dispatch({
          type: actionType.SET_USER,
          user: providerData[0],
        });

        localStorage.setItem('user', JSON.stringify(providerData[0]));
        const uid = providerData[0].uid;
        const firestore = getFirestore(app);
        const userDocRef = doc(firestore, 'users', uid);
        const userDoc = await getDoc(userDocRef);
        if (!userDoc.exists()) {
          await setDoc(userDocRef, {
            uid: uid,
            name: providerData[0].displayName,
            email: providerData[0].email,
            photoURL: providerData[0].photoURL,
            createdAt: new Date(),
            mobile: '',
          });
        }
      } catch (error) {
        console.error("Error during login:", error);
      }
    } else {
      setIsMenu(!isMenu);
    }
  };

  const logout = () => {
    setIsMenu(false);
    localStorage.clear();
    dispatch({ type: actionType.SET_USER, user: null });
    navigate('/');
  };

  useEffect(() => {
    const handleScroll = () => {
      setBgColor(window.scrollY > 50 ? 'bg-white bg-opacity-70' : 'bg-white');
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  },);

  // **New useEffect to check localStorage**
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      dispatch({
        type: actionType.SET_USER,
        user: JSON.parse(storedUser),
      });
    }
  }, [dispatch]); // Add dispatch as a dependency

  // Handle scroll lock
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    // Clean up on component unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileMenuOpen]);
  const menuRef = useRef(null);
  const otherRef = useRef(null);
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) &&
        (otherRef.current && !otherRef.current.contains(event.target))) {
        setIsMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <header>


      {/* <div className='hidden md:flex w-full h-9 bg-[#f5faff] items-center'>
        <div className='flex justify-between items-center w-full px-4 md:px-8'>
          <div className='flex items-center gap-4'>
            <p className='text-[12px] flex items-center gap-1 text-black'>
              <IoLocationOutline className='text-lg md:text-sx text-[#005eb8]' />
              1600 Heritage Landing Suite # G212, Saint Peters, Missouri 63303, United States
            </p>
          </div>
          <div className='flex items-center gap-4'>
            <p className='text-[12px] text-black'>Visit Our Linkedin Page</p>
            <div className='flex gap-2'>
              <a href=" https://www.linkedin.com/company/nexify-infosystems-llc" target="_blank" rel="noopener noreferrer" className='text-[#005eb8] hover:text-gray-300'>
                <FaLinkedinIn className='text-sx' />
              </a>
              <a href=" https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw==" target="_blank" rel="noopener noreferrer" className='text-[#005eb8] hover:text-gray-300'>
                <FaInstagram className='text-sx' />
              </a>
            </div>
          </div>
        </div>
      </div>
   */}
      <div
        className="hidden md:flex w-full h-20 items-center transition-shadow duration-300 justify-between lg:p-9 bg-white shadow-[0px_10px_0px_-10px_rgba(0,0,0,0.3)] fixed top-0 z-[9] border-b-2 border-[#e3e4eb]"
        style={{
          backdropFilter: 'blur(20px)',
          backgroundColor: 'hsla(0,0%,98%,0.08)'
        }}
      >

        <Link to='/' className='flex items-center gap-2'>
          <img src={logo} alt="logo" className='lg:w-[150px] md:w-[120px] lg:h-18 md:h-18 object-fit' />
        </Link>
        <div className='flex items-center  lg:gap-10 md:gap-8 lg:mr-10 md:mr-6 relative'>
          {location.pathname === '/job-search' || location.pathname === '/job-search-career' || location.pathname === '/my-info'
            || location.pathname === '/my-application' || location.pathname.startsWith('/product/') || location.pathname === '/upload-resume' ? (
            // Render "Find Opportunities" and "Sign In"
            <>
              <Link
                to="/job-search"
                className="text-[16px] text-[#0C5495] font-[400] p-3 hover:bg-gray-300 hover:rounded-full transition-all ease-in-out duration-100 cursor-pointer"
              >
                Find Opportunities
              </Link>
              {
                user ? (
                  <div className='relative lg:ml-[-30px]' ref={menuRef}>
                    <button
                      className='flex items-center px-3 py-2 text-[#fb9d3d] text-[16px] transition-all duration-200 font-[700]'
                      onClick={login}
                    >
                      {user.username}
                    </button>
                    {
                      isMenu && (
                        <motion.div
                          initial={{ opacity: 0, scale: 0.6 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.6 }}
                          className="absolute -left-20 w-[200px] bg-white shadow-lg text-[14px] mt-4 z-20 border border-gray-200 rounded-lg overflow-hidden p-2"
                        >
                          {
                            user ? (
                              user.email === 'projectour24@gmail.com' ? (
                                <>
                                  <Link to='/createItem' className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={() => setIsMenu(false)}>
                                    <MdAdminPanelSettings className='text-lg' />Admin Portal
                                  </Link>
                                  <p className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={logout}>
                                    <MdLogout className='text-lg' /> Logout
                                  </p>
                                </>
                              ) : (
                                <>
                                  <Link to='/my-info' className='flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg' onClick={() => setIsMenu(false)}>
                                    <FaRegUser className="text-[#005eb8] text-[25px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                                    <span className="hover:text-[#005eb8]">My Account</span>
                                  </Link>
                                  <Link to='/my-application' className='flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg' onClick={() => setIsMenu(false)}>
                                    <MdWorkOutline className="text-[#005eb8] text-[25px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                                    <span className="hover:text-[#005eb8]"> My Jobs </span>
                                  </Link>
                                  <p className='flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg' onClick={logout}>
                                    <MdLogout className="text-[#005eb8] text-[25px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                                    <span className="hover:text-[#005eb8]">  Logout </span>
                                  </p>
                                </>
                              )
                            ) : (
                              <p className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={login}>
                                Login
                              </p>
                            )
                          }
                        </motion.div>
                      )
                    }
                  </div>
                ) : (
                  <a
                    href="/Signin" // Replace with your actual login URL
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[16px] text-[#0C5495] font-[400] p-3 hover:bg-gray-300 hover:rounded-full transition-all ease-in-out duration-100 cursor-pointer"
                  >
                    Sign In
                  </a>
                )
              }
            </>
          ) : (
            <>

              {['/about', '/partners', '/service'].map((path, index) => (
                <motion.ul
                  key={index}
                  initial={{ opacity: 0, x: 200 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 200 }}
                  className='flex flex-col items-center gap-2 relative'
                >
                  <div className="flex items-center flex-col">
                    <Link
                      ref={linkRef}
                      to={path}
                      className={`text-[16px] relative ${location.pathname === path
                        ? 'text-[#005ea8] font-semibold after:scale-x-100' // ✅ Keep underline visible if active
                        : 'text-[#4a4a4a] font-[400] after:scale-x-0'
                        } hover:text-[#005ea8] transition-all ease-in-out duration-300 cursor-pointer 
                      after:absolute after:left-0 after:bottom-[-10px] after:w-full after:h-[2px] after:bg-[#005ea8] 
                      after:origin-left after:transition-transform after:duration-300 hover:after:scale-x-100`}

                      onClick={() => setIsMenu(false)}
                    >
                      {/* Dynamically show the name based on the path */}
                      {path === '/about'
                        ? 'Who We Are' : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                    </Link>


                  </div>

                </motion.ul>
              ))}
              <div className="relative flex items-center flex-col gap-2">
                <div className="flex items-center gap-1">
                  <Link

                    className={`text-[16px] ${[
                      '/consulting',
                      '/case-studies',
                    ].includes(location.pathname)
                      ? 'text-[#005ea8] font-semibold after:scale-x-100'
                      : 'text-[#4a4a4a] font-[400] after:scale-x-0'
                      } hover:text-[#005ea8] transition-all ease-in-out duration-300 cursor-pointer
                            after:absolute after:left-0 after:bottom-[-10px] after:w-full after:h-[2px] after:bg-[#005ea8]
                            after:origin-left after:transition-transform after:duration-300 hover:after:scale-x-100`}
                    onClick={handleConsultingClick}
                    ref={consultingLinkRef} // Attach ref to the link
                  >
                    Consulting
                  </Link>
                </div>
                {isConsultingDropdownOpen && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.6 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.6 }}
                    className="absolute -left-28 w-[300px] bg-white shadow-lg text-[14px] mt-7 z-20 border border-gray-200 rounded-lg overflow-hidden p-2"
                    ref={consultingDropdownRef} // Attach ref to the dropdown content
                  >
                    <div className="">
                      <Link
                        to="/consulting"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <MdOutlineBusinessCenter className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Our Consulting</span>
                      </Link>
                      <Link
                        to="/case-studies"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <MdOutlineLibraryBooks className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Consulting For  Healthcare </span>
                      </Link>
                    </div>
                  </motion.div>
                )}
              </div>

              {/* Careers Dropdown */}
              <div
                className="relative flex items-center flex-col gap-2"
              >
                <div className="flex items-center gap-1">
                  <Link
                    className={`text-[16px] ${[
                      '/consultantcareer',
                      '/faqs',
                      '/consultant-care',
                      '/benefits',
                      '/careers-at-nexify',
                      '/culture-nexify',
                      '/internal-benefits',
                      '/experienced-professionals',
                      '/students-new-grads',
                    ].includes(location.pathname)
                      ? 'text-[#005ea8] font-semibold after:scale-x-100'
                      : 'text-[#4a4a4a] font-[400] after:scale-x-0'
                      } hover:text-[#005ea8] transition-all ease-in-out duration-300 cursor-pointer
                                after:absolute after:left-0 after:bottom-[-10px] after:w-full after:h-[2px] after:bg-[#005ea8]
                                after:origin-left after:transition-transform after:duration-300 hover:after:scale-x-100`}
                    onClick={handleCareersClick}
                    ref={careersLinkRef}
                  >
                    Careers
                  </Link>
                </div>
                {isCareersDropdownOpen && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.6 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.6 }}
                    className="absolute -left-40 w-[430px] bg-white shadow-lg text-[14px] mt-7 z-20 border border-gray-200 rounded-lg overflow-hidden p-2"
                    ref={careersDropdownRef}
                  >
                    <div className="grid grid-cols-2 gap-2">
                      {/* Consultant Careers */}
                      <Link
                        to="/consultantcareer"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <MdPeopleOutline className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Consultant Careers</span>
                      </Link>

                      {/* Careers At Apex */}
                      <Link
                        to="/careers-at-nexify"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <TbMessageUser className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#ecf7ff] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Careers At Nexify</span>
                      </Link>

                      {/* Search Jobs */}
                      <Link
                        to="/job-search"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <FaSearch className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#e4eff8] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Search Jobs</span>
                      </Link>
                      <Link
                        to="/job-search-career"
                        className="flex items-center px-3 py-2 text-[#6d6d70] transition duration-150 hover:bg-gray-100 rounded-lg"
                      >
                        <AiOutlineFileSearch className="text-[#005eb8] text-[30px] mr-2 bg-gradient-to-r from-gray-100 to-[#ecf7ff] rounded-md p-1" />
                        <span className="hover:text-[#005eb8]">Search Jobs At Nexify</span>
                      </Link>
                    </div>
                  </motion.div>
                )}
              </div>


              <div className="flex items-center flex-col">
                <div>
                  <button
                    onClick={() => {
                      setIsOpen(true);
                      console.log(isOpen); // Check if isOpen is changing
                    }}

                    style={{
                      background: "linear-gradient(130deg, #d75074, #d34a7d 18%, #cf4483 26%, #c8418b 33%, #c14497 39%, #b4419d 44%, #a843a6 50%, #a33eac 56%, #a13bb5 61%, #9938bc 67%, #9036c4 74%, #8736ce 82%, #7c37d7)",
                      padding: "10px 15px",
                      borderRadius: "5px",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    className="inline-block shadow-md transition-all duration-300"
                  >
                    <motion.div
                      animate={{ rotate: [0, 20, -20, 0] }}
                      transition={{ duration: 2, ease: 'easeInOut', repeat: Infinity, repeatDelay: 1 }}
                    >
                      <MdOutlineWifiCalling3 size={20} />
                    </motion.div>
                    LET'S TALK
                  </button>
                </div>
              </div>
              <div class={`absolute top-16 right-[-80px] w-72 bg-blue-900 text-white shadow-lg transition-transform duration-300 ease-in-out z-10 p-5 ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
                {/* Close Button */}
                <button onClick={() => setIsOpen(false)} className="absolute top-3 left-3 bg-gray-700 p-2 rounded-full">
                  <FaTimes size={18} />
                </button>

                {/* Form Content */}
                <h2 className="text-md font-[600] text-center mb-4">CONTACT US</h2>

                {/* Contact for Sales */}
                <div className="mb-4 text-center">
                  <p className="text-yellow-300 text-[14px] font-[500]">Contact for Nexify Infosystems</p>

                  <div className="flex justify-center items-center mt-2">
                    <img src={USA} alt="USA Flag" className="w-6 h-6 mr-2 rounded-lg" />
                    <p className="flex items-center text-[13px]">+1-754-258-7670</p>
                  </div>
                </div>

                {/* Request a call back */}
                <div className="mb-4">
                  <p className="mt-4 text-center">OR</p>
                  <p className="font-[500] text-center">Request a call back:</p>
                  <form onSubmit={handleCallbackSubmit}>
                    <input
                      type="tel"
                      placeholder="Mobile Number"
                      className="w-full p-2 text-[13px] mt-2 text-black rounded border border-gray-300 focus:outline-none focus:ring-yellow-500"
                      value={callbackFormData.mobile}
                      name="mobile"
                      maxLength={10}
                      onChange={(e) => {
                        // Remove any non-digit characters
                        const numericValue = e.target.value.replace(/[^0-9]/g, '');
                        // Update the state with the cleaned numeric value
                        setCallbackFormData({ ...callbackFormData, mobile: numericValue });
                      }}
                      onKeyDown={(e) => {
                        // Prevent default for non-numeric characters (optional, but good for immediate feedback)
                        if (!/^[0-9]+$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                          e.preventDefault();
                        }
                      }}
                    />
                    <textarea
                      placeholder="Message"
                      className="w-full text-[13px] p-2 mt-2 text-black rounded border border-gray-300 focus:outline-none focus:ring-yellow-500"
                      value={callbackFormData.message}
                      name="message"
                      onChange={handleCallbackChange}
                      rows="3"
                    />
                    <button
                      type="submit"
                      className="w-full mt-3 bg-yellow-500 text-white py-2 rounded hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                    >
                      Submit
                    </button>
                  </form>

                </div>
                <div className=" border-b border-gray-600"></div>
                {/* Contact for Careers (Jobs) */}
                <div>
                  <p className="mt-4 text-yellow-300 font-[400] text-center">Contact for Careers (Jobs)</p>

                  <div className="flex justify-center items-center mt-2">
                    <img src={USA} alt="India Flag" className="w-6 h-6 mr-2 rounded-lg" />
                    <p className="flex items-center text-[13px]"> +1 732-612-9958</p>
                  </div>
                </div>
              </div>
              {/* <div className='relative lg:ml-[-30px]' ref={menuRef}>
                {user ? (
                  <motion.img
                    whileTap={{ scale: 0.6 }}
                    src={user.photoURL}
                    alt="user profile"
                    className='w-5 h-5 cursor-pointer drop-shadow-xl rounded-full'
                    onClick={login}
                  />
                ) : (
                  <button
                    className='flex items-center px-5 py-2 text-black text-[14px] transition-all duration-200 font-[500]'
                    onClick={login}
                  >
                    <FaRegUser className='text-lg text-[#005eb8]' />

                  </button>
                )}

                {isMenu && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.6 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.6 }}
                    className='w-52 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0 z-20'
                  >
                    {user ? (
                      user.email === 'projectour24@gmail.com' ? (
                        <>
                          <Link to='/createItem' className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={() => setIsMenu(false)}>
                            <MdAdminPanelSettings className='text-lg' />Admin Portal
                          </Link>
                          <p className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={logout}>
                            <MdLogout className='text-lg' /> Logout
                          </p>
                        </>
                      ) : (
                        <>
                          <Link to='/my-info' className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={() => setIsMenu(false)}>
                            <FaRegUser className='text-md' />My Account
                          </Link>
                          <Link to='/my-application' className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={() => setIsMenu(false)}>
                            <MdWorkOutline className='text-md' />My Jobs
                          </Link>
                          <p className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={logout}>
                            <MdLogout className='text-md' /> Logout
                          </p>
                        </>
                      )
                    ) : (
                      <p className='px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base' onClick={login}>
                        Login
                      </p>
                    )}
                  </motion.div>
                )}
              </div> */}
            </>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      <div className='md:hidden h-full flex flex-col relative shadow-sm shadow-gray-300'>
        <div className='flex items-center justify-between '>
          <div className='flex flex-row items-center gap-7 ml-4'>
            <button
              className='relative ml-0 text-black text-3xl cursor-pointer'
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <GrMenu />
            </button>

            <Link to='/' className='flex items-center gap-0'>
              <img src={logo} alt="logo" className='w-32 h-16 object-cover' />
            </Link>
            <div className="flex items-center flex-col p-2 mr-[-7px]">
              <div>
                <button
                  onClick={() => {
                    setIsOpen(true);
                    console.log(isOpen); // Check if isOpen is changing
                  }}
                  style={{
                    background:
                      "linear-gradient(130deg, #d75074, #d34a7d 18%, #cf4483 26%, #c8418b 33%, #c14497 39%, #b4419d 44%, #a843a6 50%, #a33eac 56%, #a13bb5 61%, #9938bc 67%, #9036c4 74%, #8736ce 82%, #7c37d7)",
                    borderRadius: "5px",
                    color: "#fff",
                  }}
                  className="inline-flex items-center shadow-md transition-all duration-300 p-2 text-[11px]"
                >
                   <motion.div
                      animate={{ rotate: [0, 20, -20, 0] }}
                      transition={{ duration: 2, ease: 'easeInOut', repeat: Infinity, repeatDelay: 1 }}
                    >
                      <MdOutlineWifiCalling3 size={20} className='mr-1'/>
                    </motion.div>
                  LET'S TALK
                </button>
              </div>
            </div>
            <div class={`absolute top-16 right-0 w-72 bg-blue-900 text-white shadow-lg transition-transform duration-300 ease-in-out z-10 p-5 ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
                {/* Close Button */}
                <button onClick={() => setIsOpen(false)} className="absolute top-3 left-3 bg-gray-700 p-2 rounded-full">
                  <FaTimes size={18} />
                </button>

                {/* Form Content */}
                <h2 className="text-md font-[600] text-center mb-4">CONTACT US</h2>

                {/* Contact for Sales */}
                <div className="mb-4 text-center">
                  <p className="text-yellow-300 text-[14px] font-[500]">Contact for Nexify Infosystems</p>

                  <div className="flex justify-center items-center mt-2">
                    <img src={USA} alt="USA Flag" className="w-6 h-6 mr-2 rounded-lg" />
                    <p className="flex items-center text-[13px]">+1-754-258-7670</p>
                  </div>
                </div>

                {/* Request a call back */}
                <div className="mb-4">
                  <p className="mt-4 text-center">OR</p>
                  <p className="font-[500] text-center">Request a call back:</p>
                  <form ref={form}  onSubmit={handleCallbackSubmit}>
                    <input
                      type="tel"
                      placeholder="Mobile Number"
                      className="w-full p-2 text-[13px] mt-2 text-black rounded border border-gray-300 focus:outline-none focus:ring-yellow-500"
                      value={callbackFormData.mobile}
                      name="mobile"
                      maxLength={10}
                      onChange={(e) => {
                        // Remove any non-digit characters
                        const numericValue = e.target.value.replace(/[^0-9]/g, '');
                        // Update the state with the cleaned numeric value
                        setCallbackFormData({ ...callbackFormData, mobile: numericValue });
                      }}
                      onKeyDown={(e) => {
                        // Prevent default for non-numeric characters (optional, but good for immediate feedback)
                        if (!/^[0-9]+$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                          e.preventDefault();
                        }
                      }}
                    />
                    <textarea
                      placeholder="Message"
                      className="w-full text-[13px] p-2 mt-2 text-black rounded border border-gray-300 focus:outline-none focus:ring-yellow-500"
                      value={callbackFormData.message}
                      name="message"
                      onChange={handleCallbackChange}
                      rows="3"
                    />
                    <button
                      type="submit"
                      className="w-full mt-3 bg-yellow-500 text-white py-2 rounded hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                    >
                      Submit
                    </button>
                  </form>

                </div>
                <div className=" border-b border-gray-600"></div>
                {/* Contact for Careers (Jobs) */}
                <div>
                  <p className="mt-4 text-yellow-300 font-[400] text-center">Contact for Careers (Jobs)</p>

                  <div className="flex justify-center items-center mt-2">
                    <img src={USA} alt="India Flag" className="w-6 h-6 mr-2 rounded-lg" />
                    <p className="flex items-center text-[13px]"> +1 732-612-9958</p>
                  </div>
                </div>
              </div>

          </div>

          <div className='flex items-center gap-2' ref={otherRef}>
            <div className='relative ml-2'>

              {isMobileMenuOpen && (
                <>
                  <div
                    className='fixed inset-0 bg-black bg-opacity-50 z-40'
                    onClick={() => setIsMobileMenuOpen(false)}
                  />
                  <div
                    initial={{ x: '-100%', opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: '-100%', opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300 }}
                    className='fixed top-0 left-0 w-64 h-full bg-white shadow-lg z-50  overflow-y-auto'
                  >
                    <div className='flex flex-col '>
                      <div className='flex flex-col items-center text-black p-3'>
                        <div className=' items-start text-black p-4 w-full'>
                          <Link to='/' className='flex flex-col items-start gap-2'>
                            <img src={logo} alt="logo" className='lg:w-[130px] md:w-[60px] w-[100px] lg:h-20 md:h-14 h-15 object-fit' />
                          </Link>
                        </div>
                        {['/about', '/partners', '/service'].map((path, index) => (
                          <Link
                            key={index}
                            to={path}
                            className={`w-full text-left px-4 py-4 text-[14px] transition-colors duration-200 ${location.pathname === path
                              ? 'text-[#005eb8] border-b-black'
                              : 'hover:bg-white hover:text-black border-b-gray-300'}`}
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {path === '/about'
                              ? 'About Us' : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                          </Link>
                        ))}
                        <div className="relative w-full">
                          <button
                            className={`w-full text-left  px-4 py-4 text-[14px] transition-colors duration-200 ${location.pathname.includes('/consulting') ||
                              location.pathname.includes('/case-studies')
                              ? 'text-[#005eb8 border-b-black'
                              : 'hover:bg-white hover:text-black border-b-gray-300'
                              }`}
                            onClick={() => setIsConsultingDropdownOpen(!isConsultingDropdownOpen)} // Toggle dropdown
                          >
                            Consulting {isConsultingDropdownOpen ? <VscChevronUp className="inline" /> : <VscChevronDown className="inline" />}
                          </button>
                          {isConsultingDropdownOpen && (
                            <div className="flex flex-col">
                              <Link
                                to="/consulting"
                                className="w-full text-left text-[#6d6d70] px-4 py-2 text-[13px] hover:bg-white hover:text-black"
                              >
                                <span className="hover:text-[#005eb8] text-[13px]">Our Consulting</span>
                              </Link>
                              <Link
                                to="/case-studies"
                                className="w-full text-left text-[#6d6d70] px-4 py-2 text-[13px] hover:bg-white hover:text-black"
                              >
                                <span className="hover:text-[#005eb8] text-[13px]">Consulting For  Healthcare </span>
                              </Link>
                            </div>
                          )}
                        </div>
                        {/* Careers Dropdown */}
                        <div className="relative w-full">
                          <button
                            className={`w-full text-left  px-4 py-4 text-[14px] transition-colors duration-200 ${location.pathname.includes('/consultantcareer') ||
                              location.pathname.includes('/faqs') ||
                              location.pathname.includes('/consultant-care') ||
                              location.pathname.includes('/benefits') ||
                              location.pathname.includes('/careers-at-nexify') ||
                              location.pathname.includes('/culture-nexify') ||
                              location.pathname.includes('/internal-benefits') ||
                              location.pathname.includes('/experienced-professionals') ||
                              location.pathname.includes('/students-new-grads')
                              ? 'text-[#005eb8 border-b-black'
                              : 'hover:bg-white hover:text-black border-b-gray-300'
                              }`}
                            onClick={() => setIsCareersDropdownOpen(!isCareersDropdownOpen)} // Toggle dropdown
                          >
                            Careers {isCareersDropdownOpen ? <VscChevronUp className="inline" /> : <VscChevronDown className="inline" />}
                          </button>
                          {isCareersDropdownOpen && (
                            <div className="flex flex-col">
                              <Link to="/consultantcareer" className="w-full text-left text-[#6d6d70] px-4 py-2 text-[13px] hover:bg-white hover:text-black">
                                Consultant Careers
                              </Link>
                              <Link to="/job-search" className="w-full text-left px-4 py-2 text-[#6d6d70] text-[13px] hover:bg-white hover:text-black">
                                Search Jobs
                              </Link>
                              <Link to="/careers-at-nexify" className="w-full text-left px-4 text-[#6d6d70] py-2 text-[13px] hover:bg-white hover:text-black">
                                Careers at Nexify
                              </Link>
                              <Link to="/job-search-career" className="w-full text-left px-4 text-[#6d6d70] py-2 text-[13px] hover:bg-white hover:text-black">
                                Search Jobs At Nexify
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='flex flex-col w-full h-auto bg-[#0b3155] p-0 items-center'
                        style={{
                          backgroundImage: `url(${footer})`,
                          backgroundSize: 'cover', // This will cover the entire area without repeating
                          backgroundPosition: 'center', // This will center the image
                          backgroundRepeat: 'no-repeat', // Prevent image repetition
                        }}
                      >
                        <div className='flex flex-col justify-between items-center w-full px-4 md:px-8'>

                          <div className='flex flex-col items-center gap-4 mt-4'>
                            <p className='text-sm flex flex-col items-center gap-1 text-white'>
                              <IoLocationOutline className='text-3xl text-[#f5bd00]' />
                              <span className='text-sm'>USA Office</span>
                              <span className='text-sm text-gray-400 text-center justify-center'> 1600 Heritage Landing Suite # G212, Saint Peters, Missouri 63303, United States </span>
                            </p>
                            <p className='text-sm flex flex-col items-center gap-1 text-white'>
                              <IoLocationOutline className='text-3xl text-[#f5bd00]' />
                              <span className='text-sm'>UK Office</span>
                              <span className='text-sm text-gray-400 text-center justify-center'>  381 Midsummer Blvd, Milton Keynes MK9 3HP, United Kingdom</span>
                            </p>

                          </div>
                          <div className='flex flex-col items-center gap-4 mt-4 border-t-gray-600 mb-3'>
                            <p className='text-sm text-white'>Visit Our Linkedin Page</p>
                            <div className='flex gap-2'>

                              <a href=" https://www.linkedin.com/company/nexify-infosystems-llc" target="_blank" rel="noopener noreferrer" className='text-[#005eb8] hover:text-gray-300'>
                                <FaLinkedinIn className='text-xl text-[#f5bd00]' />
                              </a>
                              <a href=" https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw==" target="_blank" rel="noopener noreferrer" className='text-[#005eb8] hover:text-gray-300'>
                                <FaInstagram className='text-xl text-[#f5bd00]' />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
